export default "__VITE_ASSET__28dec806__"